
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class FranchiseeSalesReportGrid extends Serenity.EntityGrid<FranchiseeSalesReportRow, any> {
        protected getColumnsKey() { return FranchiseeSalesReportColumns.columnsKey; }
        protected getDialogType() { return FranchiseeSalesReportDialog; }
        protected getIdProperty() { return FranchiseeSalesReportRow.idProperty; }
        protected getInsertPermission() { return FranchiseeSalesReportRow.insertPermission; }
        protected getLocalTextPrefix() { return FranchiseeSalesReportRow.localTextPrefix; }
        protected getService() { return FranchiseeSalesReportService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(0, 1);

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: FranchiseeSalesReportService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            return buttons;
        }
    }
}